export default "__VITE_ASSET__DdQp9AWO__"